import styled from "styled-components";

import {
    LockOpen as LockOpenIcon,
    LocalOfferOutlined as LocalOfferOutlinedIcon
} from '@material-ui/icons';

export const TokenContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background-color: var(--primary-main, #FB7672);
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const StyledLockOpenIcon = styled(LockOpenIcon)`
  width: 48px !important;
  height: 48px !important;
  margin-right: 1rem;
`

export const StyledLocalOfferOutlinedIcon = styled(LocalOfferOutlinedIcon)`
  width: 15px !important;
  height: 15px !important;
  margin-right: 0.5rem;
`

export const TokenTitle = styled.div`
  font-size: 1.25rem;
  line-height: 1;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
`

export const TokenDescription = styled.div`
  display: flex;
  align-items: center;
`

export const TokenPrice = styled.div`
  margin-right: 0.5rem;
  color: white;
  font-size: 1rem;
`

export const TokenDiscount = styled.div`
  display: flex;
  align-items: center;
  background-color: #0B4598;
  border-radius: 32px;
  padding: 0.25rem 0.75rem;
  color: white;
  font-size: 0.75rem;
  text-transform: uppercase;
`

export const InfoLink = styled.a`
  display: block;
  margin-top: 1.5rem;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  text-decoration: underline;
`
